import React from 'react';

import AudioPlayer from './audio-player';
import { TranscriptBlock } from '@/api/types/backend-dto-types';

interface TranscriptBlockQuoteProps {
  block: TranscriptBlock;
  caseId?: string;
  transcriptId?: string;
  onClick?: () => void;
  className?: string;
  isRecordingComplete?: boolean;
}

export const TranscriptBlockQuote = ({
  block,
  caseId,
  transcriptId,
  onClick,
  className = '',
  isRecordingComplete = true,
}: TranscriptBlockQuoteProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).closest('[data-audio-player]')) {
      e.stopPropagation();
      return;
    }
    onClick?.();
  };

  // Get speaker info from the new relation structure
  const logicalSpeaker = block.internalSpeaker?.speaker;
  const internalSpeakerName = block.internalSpeaker?.internalName;

  // Determine the display name - use logical speaker name if mapped, otherwise show as unmapped
  const speakerDisplayName =
    logicalSpeaker?.name || (internalSpeakerName ? `${internalSpeakerName}` : 'Unknown Speaker');

  // Get the speaker color
  const color = logicalSpeaker?.color ?? 'gray';

  return (
    <div
      className={`mb-2 border-gray-200 transition-colors hover:border-gray-300 ${
        onClick ? 'cursor-pointer' : ''
      } ${className}`}
      onClick={handleClick}
    >
      <div className="text-xs">
        {(logicalSpeaker || internalSpeakerName) && (
          <div className="mb-1.5 flex items-center gap-2">
            <div className={`h-1.5 w-1.5 rounded-full bg-${color}-400`} />
            <span className={`font-medium text-${color}-600`}>{speakerDisplayName}</span>
            {isRecordingComplete && (
              <div data-audio-player className="ml-auto">
                {caseId && transcriptId ? (
                  <AudioPlayer className="h-5 w-5" blockId={block.id} caseId={caseId} transcriptId={transcriptId} />
                ) : (
                  <span className="text-xs text-gray-400">Audio unavailable</span>
                )}
              </div>
            )}
          </div>
        )}

        <p className="pr-4 text-gray-600 italic">"{block.content}"</p>
      </div>
    </div>
  );
};
